import { IsBoolean } from "class-validator";

export class EmailValidate {
  @IsBoolean()
  readonly valid: boolean;

  constructor(init?: EmailValidate) {
    this.valid = init?.valid!;
  }
}

export default EmailValidate;
